import React, { useState, useRef, useEffect } from "react";
import {
    Dialog,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Slide,
    Box,
    Tooltip,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import ZoomInIcon from "@mui/icons-material/ZoomIn"
import ZoomOutIcon from "@mui/icons-material/ZoomOut"
import RestartAltIcon from "@mui/icons-material/RestartAlt"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const FullScreenImageViewer = ({
    open,
    imageUrl,
    title = "Image Preview",
    onClose,
}) => {
    const [zoom, setZoom] = useState(1);
    const containerRef = useRef(null);

    const handleZoomIn = () => {
        setZoom((prev) => Math.min(prev + 0.25, 5));
    };

    const handleZoomOut = () => {
        setZoom((prev) => Math.max(prev - 0.25, 0.5));
    };

    const handleReset = () => {
        setZoom(1);
    };

    useEffect(() => {
        if (containerRef && containerRef.current) {
            // scroll to top so top of the image is visible under the fixed AppBar
            containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [zoom, open]);

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
        >
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Typography
                        sx={{ ml: 2, flex: 1 }}
                        variant="h6"
                    >
                        {title}
                    </Typography>

                    <Tooltip title="Zoom Out">
                        <IconButton color="inherit" onClick={handleZoomOut}>
                            <ZoomOutIcon />
                        </IconButton>
                    </Tooltip>

                    <Typography sx={{ mx: 1 }}>
                        {Math.round(zoom * 100)}%
                    </Typography>

                    <Tooltip title="Zoom In">
                        <IconButton color="inherit" onClick={handleZoomIn}>
                            <ZoomInIcon />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Reset Zoom">
                        <IconButton color="inherit" onClick={handleReset}>
                            <RestartAltIcon />
                        </IconButton>
                    </Tooltip>
                </Toolbar>
            </AppBar>

            <Box
                ref={containerRef}
                sx={{
                    height: "100%",
                    width: "100%",
                    bgcolor: "#000",
                    overflow: "auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    p: 2,
                    /* ensure content is not hidden under the fixed AppBar */
                    pt: { xs: '56px', sm: '64px' }
                }}
            >
                <img
                    src={`data:image/png;base64,${imageUrl}`}
                    alt={title}
                    style={{
                        transform: `scale(${zoom})`,
                        transformOrigin: "top center",
                        transition: "transform 0.2s ease",
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                    }}
                />
            </Box>
        </Dialog>
    )
}

export default FullScreenImageViewer